import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "gfu-project-banner gfu-project-banner--secondary" }
const _hoisted_2 = {
  key: 0,
  class: "gfu-project-banner-gallery gfu-layout-wrapper"
}
const _hoisted_3 = { class: "gfu-1of1 gfu-1of3--xl gfu-project-banner-gallery__body" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_title = _resolveComponent("project-title")
  const _component_project_banner = _resolveComponent("project-banner")
  const _component_project_summary = _resolveComponent("project-summary")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "gfu-project-banner__content-wrapper",
      style: _normalizeStyle($options.featuredImageStyle)
    }, [
      _createVNode(_component_project_title, {
        "project-home-url": $props.projectHomeUrl,
        "project-name": $props.projectName,
        creator: $props.creator,
        "co-creators": $props.coCreators,
        "project-short-description": $props.projectShortDescription,
        "project-id": $props.projectId
      }, null, 8 /* PROPS */, ["project-home-url", "project-name", "creator", "co-creators", "project-short-description", "project-id"]),
      (!$props.compactMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_project_banner, {
              "project-url-name": $props.projectUrlName,
              "project-creator-url-name": $props.projectCreatorUrlName,
              items: $props.galleryItems
            }, null, 8 /* PROPS */, ["project-url-name", "project-creator-url-name", "items"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_project_summary, {
                "project-summary-navigation": $props.projectSummaryNavigation,
                "project-last-update": $props.projectLastUpdate
              }, null, 8 /* PROPS */, ["project-summary-navigation", "project-last-update"])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ], 4 /* STYLE */)
  ]))
}